import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';

// SignalR handles established-connection reconnects; initial failures need a separate retry.
export const connectShareRequestNotifications = ({
  url,
  token,
  onEvent,
  onConnected,
  onInboxChanged = () => {}
}) => {
  const connection = new HubConnectionBuilder()
    .withUrl(url, { accessTokenFactory: () => token })
    .withAutomaticReconnect({
      nextRetryDelayInMilliseconds: context =>
        Math.min(30000, 1000 * 2 ** Math.min(context.previousRetryCount, 5))
    })
    .configureLogging(LogLevel.None)
    .build();
  let disposed = false;
  let retryTimer;
  const receive = event => {
    if (!disposed) onEvent(event);
  };
  const connected = () => {
    if (!disposed) onConnected();
  };
  const start = async () => {
    if (disposed) return;
    try {
      await connection.start();
      if (disposed) {
        await connection.stop();
        return;
      }
      connected();
    } catch {
      if (!disposed) retryTimer = setTimeout(start, 5000);
    }
  };
  const inboxChanged = () => {
    if (!disposed) onInboxChanged();
  };
  connection.on('InboxChanged', inboxChanged);
  connection.on('ShareRequestEvent', receive);
  connection.onreconnected(connected);
  connection.onclose(() => {
    if (!disposed) retryTimer = setTimeout(start, 5000);
  });
  start();
  return () => {
    disposed = true;
    clearTimeout(retryTimer);
    connection.off('ShareRequestEvent', receive);
    connection.off('InboxChanged', inboxChanged);
    connection.stop().catch(() => {});
  };
};
